
import { Container } from "react-bootstrap";
import "./Common_Banner.css";

const Common_Banner = ({ bannerImg, title}) => {
  return (
    <section
      className="Common_Banner"
      style={{ backgroundImage: `url(${bannerImg})` }}
    >
      <div className="banner_overlay">
        <Container>
          {/* Banner Title */}
          <div className="banner_title">
            <h1>{title}</h1>
          </div>

        </Container>
      </div>
    </section>
  );
};

export default Common_Banner;
